// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.u6EM0NwOc8jRAlCz5Fn3{
  display: grid;
  height: 100%;
}

.UC6Dj4MEsrhMuVE_ndk2 {
  font-weight: 800;
  padding: 2rem;
  font-size: 1.8rem;
}

.FUBpTeAX3vPV35Rlp0Hz{
  display: flex;
  align-items: center;
  padding: 0.5rem;
  gap: 2rem;
 }

.ZA03YtEQounFQgInRrG8 {
  width: 2rem;
  height: 2rem;
}

.LC5d9AwcPzyZqm4ojh4Q {
  margin-top: 60px;
  margin-bottom: 25px;
  margin-left: 10px;
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-transform: uppercase;

  color: #000000;
}

.td0faJgLC9YmrwU9LI9a{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 1rem;
  width: 100%;
  height: 100%;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/HomePage/index.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;CACV;;AAED;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;;EAEzB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf","sourcesContent":[".card{\n  display: grid;\n  height: 100%;\n}\n\n.h1 {\n  font-weight: 800;\n  padding: 2rem;\n  font-size: 1.8rem;\n}\n\n.header{\n  display: flex;\n  align-items: center;\n  padding: 0.5rem;\n  gap: 2rem;\n }\n\n.button {\n  width: 2rem;\n  height: 2rem;\n}\n\n.dividerText {\n  margin-top: 60px;\n  margin-bottom: 25px;\n  margin-left: 10px;\n  font-family: \"Montserrat\";\n  font-style: normal;\n  font-weight: 700;\n  font-size: 20px;\n  line-height: 27px;\n  text-transform: uppercase;\n\n  color: #000000;\n}\n\n.flex{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n  width: 100%;\n  height: 100%;\n  padding: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `u6EM0NwOc8jRAlCz5Fn3`,
	"h1": `UC6Dj4MEsrhMuVE_ndk2`,
	"header": `FUBpTeAX3vPV35Rlp0Hz`,
	"button": `ZA03YtEQounFQgInRrG8`,
	"dividerText": `LC5d9AwcPzyZqm4ojh4Q`,
	"flex": `td0faJgLC9YmrwU9LI9a`
};
export default ___CSS_LOADER_EXPORT___;
